// extracted by mini-css-extract-plugin
module.exports = {"layout":"_1KLinzxBK0NMMZaAR7zncg"};